import script from "./MatchSubjectScore.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchSubjectScore.vue?vue&type=script&setup=true&lang=js"

import "./MatchSubjectScore.vue?vue&type=style&index=0&id=668ca62e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668ca62e"]])

export default __exports__